import React from "react";
import {
    Box,
    Typography,
    Button,
    IconButton,
    CircularProgress,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

const PageHeader = ({ title, onBack, onSave, saving, openMediaPanel, t }) => {
    // Failsafe for t function - create a simple fallback if t isn't provided
    const translate = (key, defaultText) => {
        if (typeof t === 'function') {
            return t(key, defaultText);
        }
        // Fallback if t is not a function
        return defaultText || key;
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton onClick={onBack}>
                    <Icon name="arrowLeft" />
                </IconButton>
                <Typography variant="h4">{title}</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
                <Button 
                    variant="outlined" 
                    onClick={openMediaPanel}
                    startIcon={<Icon name="image" />}
                >
                    {translate('product.detail.media', 'Media')}
                </Button>
                <Button 
                    variant="contained" 
                    onClick={onSave}
                    disabled={saving || !title}
                    startIcon={saving ? <CircularProgress size={20} /> : <Icon name="save" />}
                >
                    {saving ? translate('common.saving', 'Saving...') : translate('common.save', 'Save')}
                </Button>
            </Box>
        </Box>
    );
};

export default PageHeader;